module.exports = __webpack_public_path__ + "static/media/workflow_image2.9b81a797.webp";